import type { ToolHistoryEntry } from '@vexalyn/shared';

export class ToolHistory {
  private readonly entries: ToolHistoryEntry[] = [];

  constructor(private readonly limit = 15) {}

  add(entry: Omit<ToolHistoryEntry, 'timestamp'>): void {
    this.entries.push({ ...entry, timestamp: Date.now() });
    while (this.entries.length > this.limit) this.entries.shift();
  }

  list(): readonly ToolHistoryEntry[] {
    return this.entries.map((entry) => ({ ...entry }));
  }
}

export function previewToolOutput(value: unknown, maxLength = 500): string {
  const text = typeof value === 'string' ? value : JSON.stringify(value);
  return text.length > maxLength ? `${text.slice(0, maxLength)}...[truncated]` : text;
}

